import React from "react";
import RelationsTotals from "@/components/RelationsTotals/RelationsTotals";
import { useParams } from "react-router-dom";
import { usePackagingOrderRelations } from "@/pages/packaging/usePackagings";
import Table from "@/components/Table/Table";

function PackagingOrderRelations() {
  let { packagingId: id } = useParams();
  const packagingId = Number(id);

  const { data, isLoading } = usePackagingOrderRelations({ packagingId });

  return (
    <>
      <RelationsTotals
        title={"Orders"}
        isLoading={isLoading}
        count={data?.total || 0}
      />
      <Table
        loading={isLoading}
        data={data?.relations}
        emptyState={{ hide: true }}
        hideRaster={true}
        columns={[
          {
            label: "Year",
            key: "year",
          },
          {
            label: "Purchased",
            key: "po",
          },
          {
            label: "Sold",
            key: "so",
          },
        ]}
        rowKey={"year"}
      />
    </>
  );
}

export default PackagingOrderRelations;
